import EventBus from '@/event-bus';

const commonNotificationConfig = {
  minimumTimeout: 4000,
  timeout: 10000,
  button: {
    text: 'Close',
  },
};

const defaultConfigByType = {
  error: {
    colour: 'error',
  },
  info: {
    button: {
      colour: 'primary',
    },
  },
  success: {
    colour: 'success',
  },
};

function show(text, notificationType, customNotificationConfig) {
  if (!text) {
    return;
  }

  const notificationConfig = _.merge({},
    commonNotificationConfig,
    defaultConfigByType[notificationType],
    customNotificationConfig,
    { text });
  EventBus.$emit('notification', notificationConfig);
}

export default {
  error: text => show(text, 'error'),
  info: text => show(text, 'info'),
  show,
  success: text => show(text, 'success'),
};
